<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="角色管理">
      <a-button slot="extra" type="primary" @click="handleNewRole">新建角色</a-button>
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item label="角色名称">
              <a-input
              v-model="searchP.rolename"
                  placeholder="请输入角色名称"
              ></a-input>
          </a-form-item>
          <a-form-item label="有效性">
            <a-select v-model="searchP.iseffective"  placeholder="" style="width:100px;">
                <a-select-option value="">
                全部
                </a-select-option>
                <a-select-option value="1">
                有效
                </a-select-option>
                <a-select-option value="0">
                无效
                </a-select-option>
            </a-select>
          </a-form-item>

         
          <a-form-item>
              <a-button
                  type="primary"
                  htmlType="submit"
                  :key="this.loading.key"

              >筛选</a-button>
          </a-form-item>
          <a-form-item>
            <a-button
                    type="default"
                    htmlType="submit"
                    :key="this.loading.key"
                    @click="handleSearchReset"
                >重置</a-button>
            </a-form-item>
      </a-form>
    </a-card>

    <!-- 系统列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="code" >
        <span slot="iseffective" slot-scope="text">{{ ['无效', '有效'][text] }}</span>
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
         <span>
            <router-link
                    :to="{
                    path:'detailrole',
                    query: {
                        id: record.id
                    }
                }"
                >查看</router-link>
          </span>
          <span>
            <router-link
                    :to="{
                    path:'editrole',
                    query: {
                        id: record.id
                    }
                }"
                >编辑</router-link>
          </span>
          <span>
            <router-link
                    :to="{
                    path:'roleauth',
                    query: {
                        id: record.id
                    }
                }"
                >授权</router-link>
          </span>
          <span>
            <a-popconfirm  @confirm="() => onRoleDisable(record)" v-if="record.iseffective == '1'">
                <template slot="title">
                    <p>{{ '确认将' + record.name+ '转为无效？' }}</p>
                </template>
              <a>无效</a>
            </a-popconfirm>

            <a-popconfirm  @confirm="() => onRoleActive(record)" v-if="record.iseffective == '0'">
                <template slot="title">
                    <p>{{ '确认将' + record.name+ '转为有效？' }}</p>
                </template>
              <a>有效</a>
            </a-popconfirm>
          </span>
         
        </div>
      </template>
    </a-table>

    <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />
 
 
  </div>
</template>
<script>
const columns = [
    {
        title: '角色编码',
        dataIndex: 'code',
        align: 'center',
        width:120
    },
    {
        title: '角色名称',
        dataIndex: 'name',
        align: 'center',
        width: 120,
        ellipsises:true
    },
    {
        title: '有效性',
        dataIndex: 'iseffective',
        scopedSlots: { customRender: 'iseffective' },
        align: 'center',
        width: 120,
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }

];
const data = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            searchP:{
                rolename:'',//用户姓名
                iseffective:'',
                total:0,
                pageSize:0,
                page:undefined,
            },
            tLoading:true,
        };
    },
    methods: {
        getRoleList(){
            let c_params = {
                ...this.searchP,
                urlparams:false,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "rolecenter/selectRole",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.searchP.total = result.totalRecords;
                this.searchP.pageSize = result.pageSize;
                this.searchP.page = result.page;
            })
        },
        handlePageChange(c_p){
            this.searchP.page = c_p;
            this.updateRoute();
        },
        updateRoute(){
            this.$router.push({
                query: {
                    rolename:this.searchP.rolename,
                    iseffective:this.searchP.iseffective,
                    page:this.searchP.page
                }
            });
        },
        handleSearchReset(){
            this.searchP.page = 1;
            this.searchP.rolename = '';
            this.searchP.iseffective = '';
            this.updateRoute();
        },
        handleNewRole(){
            this.$router.push({
                path: "addrole",
                query: {id:''}
            });
        },
        handleSubmit(e){
            e.preventDefault();
            this.searchP.page = 1;
            this.updateRoute()
        },
        //改成无效
        onRoleDisable(key) {
            let c_params = {
                id:key.id,
                iseffective:0
            }
            this.$store.dispatch({
                type: "rolecenter/activeRole",
                params: c_params
            }).then((res) => {
                
                if(res.status == '200'){
                    this.getRoleList();
                }
            });
        },
        //转成有效
        onRoleActive(key){
            let c_params = {
                id:key.id,
                iseffective:1
            }
            this.$store.dispatch({
                type: "rolecenter/activeRole",
                params: c_params
            }).then((res) => {
                
                if(res.status == '200'){
                    this.getRoleList();
                }
            });
        }

    },

    components:{
    },
    watch: {
        '$route' () {
            this.$router.go(0);
        }
    },
    mounted(){
        let query = this.$route.query;
        this.searchP.rolename = query.rolename ? query.rolename : '';
        this.searchP.iseffective = query.iseffective ? query.iseffective : '';
        this.searchP.page = query.page ? +query.page : 1;
        this.getRoleList();
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
